module.exports = __webpack_public_path__ + "static/media/wind-mill-yellow.a4fb4914.svg";